import { render, staticRenderFns } from "./JournalDoor.vue?vue&type=template&id=85c2fa1e"
import script from "./JournalDoor.vue?vue&type=script&lang=js"
export * from "./JournalDoor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports